export default __webpack_public_path__ + "static/media/valenzuela.5fe08911.jpg";